export enum InstrumentIcon {
  Amex = 'amex',
  Diners = 'diners',
  Discover = 'discover',
  Elo = 'elo',
  Jcb = 'jcb',
  MasterCard = 'mastercard',
  Maestro = 'maestro',
  UnionPay = 'unionpay',
  Visa = 'visa',
  PayPal = 'paypal',
  TransbankWebpay = 'transbank',
  Ideal = 'ideal',
  Subsidiary = 'subsidiary',
  ApplePay = 'applepay',
  Bancontact = 'bancontact',
  GenericCard = 'genericcard',
  GooglePay = 'googlepay',
  DirectDebit = 'directdebit',
  ECommerceConnect = 'ecommerceconnect',
  NuveiTwint = 'nuveitwint',
  SEPA = 'sepa',
  Delivery = 'delivery',
  OnlinePayment = 'onlinepayment',
  BankTransfer = 'branktransfer',
  Yookassa = 'yookassa',
  DirectDebitPostFinance = 'directdebitpostfinance',
  DenizBank = 'denizbank',
  PayByInvoice = 'paybyinvoice',
  Klarna = 'klarna',
}
